// Financial.jsx
import React, { useState } from 'react';

const styles = {
  container: {
    padding: '20px',
    backgroundColor: '#fff',
    borderRadius: '8px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
    maxWidth: '800px',
    margin: '0 auto'
  },
  title: {
    textAlign: 'center',
    color: '#007bff',
    marginBottom: '20px'
  },
  section: {
    marginBottom: '30px',
    padding: '20px',
    border: '1px solid #e0e0e0',
    borderRadius: '8px',
    backgroundColor: '#f9f9f9'
  },
  label: {
    display: 'block',
    marginBottom: '8px',
    fontWeight: 'bold',
    color: '#333'
  },
  select: {
    width: '100%',
    padding: '10px',
    marginBottom: '15px',
    borderRadius: '6px',
    border: '1px solid #ccc',
    fontSize: '16px',
    boxSizing: 'border-box'
  },
  input: {
    width: '100%',
    padding: '10px',
    borderRadius: '6px',
    border: '1px solid #ccc',
    fontSize: '16px',
    boxSizing: 'border-box'
  },
  buttonGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: '15px'
  },
  btn: {
    padding: '14px 20px',
    backgroundColor: '#007bff',
    color: 'white',
    border: 'none',
    borderRadius: '6px',
    fontSize: '16px',
    fontWeight: 'bold',
    cursor: 'pointer',
    textAlign: 'center',
    transition: 'background-color 0.3s'
  }
};

function Financial() {
  const [period, setPeriod] = useState('custom');
  const [customDate, setCustomDate] = useState(new Date().toISOString().split('T')[0]); // YYYY-MM-DD format

  const periodOptions = [
    { value: 'custom', label: 'Custom Date' },
    { value: 'this_fy', label: 'This Financial Year to Date' },
    { value: 'last_fy', label: 'Last Financial Year to Date' },
    { value: 'this_month', label: 'This Month to Date' },
    { value: 'last_3_months', label: 'Last 3 Months to Date' },
    { value: 'last_12_months', label: 'Last 12 Months to Date' },
  ];

  const getDisplayText = () => {
    if (period === 'custom') {
      const date = new Date(customDate);
      return `As of ${date.toLocaleDateString('en-GB')}`;
    }
    return periodOptions.find(p => p.value === period)?.label || 'Balance Sheet';
  };

  const downloadBalanceSheet = () => {
    let endpoint = '/financial/balance-sheet';
    if (period === 'custom') {
      endpoint += `?date=${customDate}`;
    } else {
      endpoint += `?period=${period}`;
    }

    const link = document.createElement('a');
    link.href = `https://kigaawater.inkenya.co.ke/api${endpoint}`;
    link.download = `Balance_Sheet_${getDisplayText().replace(/[^a-z0-9]/gi, '_')}.pdf`;
    link.target = '_blank';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const downloadReport = (endpoint, filename) => {
    const link = document.createElement('a');
    link.href = `https://kigaawater.inkenya.co.ke/api${endpoint}`;
    link.download = filename;
    link.target = '_blank';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div style={styles.container}>
      <h2 style={styles.title}>Financial Statements</h2>

      {/* Balance Sheet Section */}
      <div style={styles.section}>
        <h3 style={{ textAlign: 'center', marginBottom: '20px' }}>Balance Sheet</h3>

        <label style={styles.label}>Select Period</label>
        <select
          value={period}
          onChange={(e) => setPeriod(e.target.value)}
          style={styles.select}
        >
          {periodOptions.map(opt => (
            <option key={opt.value} value={opt.value}>{opt.label}</option>
          ))}
        </select>

        {period === 'custom' && (
          <>
            <label style={styles.label}>Select Date</label>
            <input
              type="date"
              value={customDate}
              onChange={(e) => setCustomDate(e.target.value)}
              style={styles.input}
            />
          </>
        )}

        <button style={styles.btn} onClick={downloadBalanceSheet}>
          Download Balance Sheet – {getDisplayText()}
        </button>
      </div>

      {/* Other Reports */}
      <div style={styles.buttonGroup}>
        <button style={styles.btn} onClick={() => downloadReport('/financial/income-statement', 'Income_Statement.pdf')}>
          Download Income Statement (PDF)
        </button>
        <button style={styles.btn} onClick={() => downloadReport('/financial/cash-flow', 'Cash_Flow.pdf')}>
          Download Cash Flow Statement (PDF)
        </button>
        <button style={styles.btn} onClick={() => downloadReport('/financial/ledger?coa_id=1', 'Ledger_Cash.csv')}>
          Download Ledger (Cash)
        </button>
      </div>
    </div>
  );
}

export default Financial;